import React from 'react';
import { Drawer, Dialog, Box, useMediaQuery, useTheme } from '@mui/material';

import { TOKENS } from '../theme';

// Bottom drawer on mobile, centered modal on desktop (≥ md). Each sheet
// keeps the same children — only the outer container swaps.
export default function ResponsiveSheet({
  open,
  onClose,
  children,
  maxWidth = 'sm',
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (isDesktop) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '90vh',
          },
        }}
      >
        {children}
      </Dialog>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: '100% !important',
          maxWidth: '100% !important',
          left: 0,
          right: 0,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: '92vh',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            background: TOKENS.slate200,
          }}
        />
      </Box>
      {children}
    </Drawer>
  );
}
